import React, { useEffect, useState } from 'react'
// import './dashboard.css'
import './adminpanel.css'
import { useAuthContext } from '../../Hooks/useAuthContext'
import axios from 'axios'
import { FaAlignLeft, FaSignOutAlt, FaTimes, FaUserAlt } from 'react-icons/fa'
import { toast } from 'wc-toast'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import AdminSidebar from './AdminSideBar'
import Loader from '../../Component/Loader/Loader'

function Users() {
  const navigate                              = useNavigate()
  const { user, dispatch }                    = useAuthContext()
  const [sidemenu, setSideMenu]               = useState(false)
  const [shouldMenuSlide, setShouldMenuSlide] = useState(false)
  const [dashUser, setDashUser]               = useState(false)
  const [data, setData]                       = useState([])
  const [editMode, setEditMode]               = useState(false)
  const [userId, setUserId]                   = useState(null)
  const [updateTrigger, setUpdateTrigger]     = useState(null)
  const [loading, setLoading]                 = useState(true)
  const [formData, setFormData]               = useState({ currency: '', amount: '' })

  /* Auth guard */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/isadmin`, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then(r => {
      if (r.data.admin)     { /* ok */ }
      else if (r.data.user) navigate('/admin-panel')
      else                  navigate('/')
    }).catch(e => console.log(e))
  }, [user.token, navigate])

  /* Fetch users */
  useEffect(() => { fetchUsers() }, [user.token, updateTrigger])

  const fetchUsers = async () => {
    setLoading(true)
    try {
      const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/users`, {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      setData(r.data || [])
    } catch (error) {
      console.error(error)
      toast.error('Failed to load users')
    } finally {
      setLoading(false)
    }
  }

  const logout = () => {
    dispatch({ type: 'LOGOUT', payload: null })
    setTimeout(() => navigate('/rf-admin'), 3000)
  }

  const handleChange = (e) => {
    const { id, value } = e.target
    setFormData(prev => ({ ...prev, [id]: value }))
  }

  const handleEditClick = (id, minimumWithdrawal) => {
    setUserId(id)
    setFormData({
      currency: minimumWithdrawal?.currency || '',
      amount:   minimumWithdrawal?.amount   ?? '',
    })
    setEditMode(true)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const amountValue = formData.amount === ''
      ? ''
      : isNaN(Number(formData.amount)) ? formData.amount : Number(formData.amount)

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/update-minimum-withdrawal/`,
        { userId, currency: formData.currency, amount: amountValue },
        { headers: { Authorization: `Bearer ${user.token}` } }
      )
      toast.success('Minimum withdrawal updated')
      setEditMode(false)
      setUpdateTrigger(prev => !prev)
    } catch (error) {
      console.error(error)
      toast.error(error?.response?.data?.message || 'Failed to update minimum withdrawal')
    }
  }

  const getMinCurrency = (u) => u?.minimumWithdrawal?.currency || '—'
  const getMinAmount   = (u) => {
    const val = u?.minimumWithdrawal?.amount
    return (val === null || val === undefined || val === '') ? '—' : val
  }

  return (
    <div className="admin dashboard">

      {/* ── Header ──────────────────────────────────────── */}
      <div className="dashboard-header">
        <div className="rights-side">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <p>
              {process.env.REACT_APP_APP_NAME}
              <span className="admin-badge">Admin</span>
            </p>
          </Link>
          <FaAlignLeft size={18} onClick={() => {
            setShouldMenuSlide(true)
            setSideMenu(!sidemenu)
          }} />
        </div>

        <div className="left-side">
          <div className="dh-avatar" onClick={() => setDashUser(p => !p)}>
            <FaUserAlt size={14} />
          </div>
          {dashUser && (
            <div className="user-menu">
              <p className="logout" onClick={logout}>
                <FaSignOutAlt size={13} /> Logout
              </p>
            </div>
          )}
        </div>
      </div>

      {/* ── Sidebar — direct child of .dashboard ────────── */}
      {sidemenu && (
        <AdminSidebar
          shouldMenuSlide={shouldMenuSlide}
          onClose={() => setSideMenu(false)}
        />
      )}

      {/* ── Body ─────────────────────────────────────────── */}
      <div className="dashboard-main-section">
        <div className="loan-container">

          <div className="table-head">
            <div>
              <div className="db-breadcrumb">Admin &nbsp;/&nbsp; <span>Users</span></div>
              <h2>Users</h2>
            </div>
          </div>

          {loading ? (
            <Loader />
          ) : (
            <div className="db-card">
              <div className="db-card__bar" />
              <div className="loan-table">
                <table className="equal-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Min W/D Currency</th>
                      <th>Min W/D Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map(u => (
                        <tr key={u._id}>
                          <td>{u.firstname} {u.lastname}</td>
                          <td>{u.email}</td>
                          <td>{getMinCurrency(u)}</td>
                          <td>{getMinAmount(u)}</td>
                          <td>
                            <div className="action-tb">
                              <button
                                className="db-btn db-btn--ghost db-btn--sm"
                                onClick={() => handleEditClick(u._id, u.minimumWithdrawal)}
                              >
                                Edit
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="no-loan-message">No users found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

        </div>
      </div>

      {/* ── Edit overlay ─────────────────────────────────── */}
      {editMode && (
        <div className="deposits-form">
          <button className="wd-close" onClick={() => setEditMode(false)} aria-label="Close">
            <FaTimes size={14} />
          </button>
          <div className="send-money-container" style={{ width: '100%', maxWidth: '480px' }}>
            <form className="send-money-form" onSubmit={handleSubmit}>
              <h2>Edit Minimum Withdrawal</h2>

              <div className="send-money-form-group">
                <label htmlFor="currency">Currency <span>*</span></label>
                <select id="currency" value={formData.currency} onChange={handleChange} required>
                  <option value="" disabled>Select currency</option>
                  <option value="USD">USD – US Dollar</option>
                  <option value="EUR">EUR – Euro</option>
                  <option value="GBP">GBP – British Pound</option>
                </select>
              </div>

              <div className="send-money-form-group">
                <label htmlFor="amount">Minimum Amount <span>*</span></label>
                <input
                  type="number"
                  id="amount"
                  placeholder="Enter minimum withdrawal amount"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                />
              </div>

              <div style={{ padding: '0 2rem' }}>
                <button type="submit" className="send-money-send-btn">
                  Save Changes →
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  )
}

export default Users